import type { FC } from "react";
import React from "react";

import { Badge } from "../../../Badge";

import type {
    BadgeProps,
    IconBadgeProps,
    IEmojiBadgeProps,
    IImageBadgeProps,
} from "../../../Badge/Badge";

const PICTURE_BADGE_TEST_ID = "picture-badge-test-id";

type ConstantBadgeProps = "size" | "stroke";

type PictureBadgeProps =
    | Omit<IconBadgeProps, ConstantBadgeProps>
    | Omit<IImageBadgeProps, ConstantBadgeProps>
    | Omit<IEmojiBadgeProps, ConstantBadgeProps>;

export const PictureBadge: FC<PictureBadgeProps> = (props) => {
    return (
        <Badge
            {...(props as BadgeProps)}
            stroke
            data-tsid={PICTURE_BADGE_TEST_ID}
        />
    );
};

PictureBadge.displayName = "Picture.Badge";

export default PictureBadge;
